import Odometer from 'odometer';

import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    const od = new Odometer({
      el: this.element,
      value: 0,
      format: 'ddd ddd ddd',
      theme: 'minimal'
    });

    od.update(this.data.get('value'))
  }
}
